"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : GRID : ITEM : STYLES --------------- ++++++++++ */


var _default = {
  griditem: {
    extend: [_index.classStyleHelper.direction, _index.classStyleHelper.align]
  }
};
exports.default = _default;